import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
// import userReducer from "./slices/userSlice";
// import notificationReducer from "./slices/notificationSlice";
import { axiosMiddleware } from "./api/middleware";
import globalReducer from "./state";
import { setupListeners } from "@reduxjs/toolkit/query";
// import { api } from "./state/api";

// const middlewares = [api.middleware, axiosMiddleware];

const store = configureStore({
  reducer: {
    auth: authReducer,
    // user: userReducer,
    // notification: notificationReducer,
    global: globalReducer,
    // [api.reducerPath]: api.reducer,
  },
  // middleware: (getDefaultMiddleware) =>
  //   getDefaultMiddleware().concat(...middlewares),
});

setupListeners(store.dispatch);

export default store;
